// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3TK8L","rootNoMargin":"styles_rootNoMargin__1WYfV"};